import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.js';
import { backgroundColorToken } from '../Button/Button.mappers.js';
import { Divider as DividerMemoized } from '../Divider/Divider.js';
import { Tooltip } from '../Tooltip/Tooltip.js';
import { useDirectionContext, Direction } from '../../contexts/session/Locale.js';
import { FloatingButton as FloatingButtonMemoized } from './FloatingButton.js';
import { getDividerColor } from './FloatingButton.mappers.js';
import { FloatingButtonGroupStyled } from './FloatingButtonGroup.styled.js';

var _excluded = ["hierarchy", "items", "size"];
/** A wrapper for stacking FloatingButton components. */
var FloatingButtonGroup = function FloatingButtonGroup(_ref) {
  var _ref$hierarchy = _ref.hierarchy,
    hierarchy = _ref$hierarchy === void 0 ? 'primary' : _ref$hierarchy,
    items = _ref.items,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var direction = useDirectionContext();
  var buttonRefs = React.useRef([]);
  var backgroundColor = backgroundColorToken(hierarchy, true);
  var handleFocus = function handleFocus(event, originalOnFocus) {
    originalOnFocus === null || originalOnFocus === void 0 || originalOnFocus(event);
    var currentButton = event.currentTarget;
    currentButton.style.zIndex = '1';
    buttonRefs.current.forEach(function (button) {
      // eslint-disable-next-line no-param-reassign
      if (button !== currentButton) button.style.zIndex = '0';
    });
  };
  return /*#__PURE__*/React.createElement(FloatingButtonGroupStyled, _extends({}, rest, {
    role: "group",
    $isRTL: direction === Direction.RTL,
    $count: items.length,
    backgroundColor: backgroundColor,
    borderRadius: "base",
    boxShadow: "bottom-m"
  }), items.map(function (props, index) {
    var canShowTooltip = props.tooltip && props.state !== 'loading';
    var button = /*#__PURE__*/React.createElement(FloatingButtonMemoized, _extends({}, props, {
      ref: function ref(_ref2) {
        if (_ref2) buttonRefs.current[index] = _ref2;
      },
      "data-drone-index": index,
      onFocus: function onFocus(event) {
        return handleFocus(event, props.onFocus);
      },
      hierarchy: hierarchy,
      size: size
    }));
    var dividerColor = getDividerColor(hierarchy);
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement(React.Fragment, {
        key: "".concat(props.label, "-").concat(index)
      }, index !== 0 && /*#__PURE__*/React.createElement(Box, {
        display: "flex",
        alignItems: "center",
        backgroundColor: backgroundColor,
        py: size === 'l' ? '12' : '8'
      }, /*#__PURE__*/React.createElement(DividerMemoized, {
        direction: "vertical",
        color: dividerColor
      })), canShowTooltip ? /*#__PURE__*/React.createElement(Tooltip, {
        title: props.label || '',
        pointerPosition: props.tooltip
      }, button) : button)
    );
  }));
};
FloatingButtonGroup.defaultProps = {
  hierarchy: 'primary',
  size: 'l'
};
var FloatingButtonGroupMemoized = /*#__PURE__*/React.memo(FloatingButtonGroup);
FloatingButtonGroupMemoized.displayName = 'FloatingButtonGroup';

export { FloatingButtonGroup as BaseFloatingButtonGroup, FloatingButtonGroupMemoized as FloatingButtonGroup };
//# sourceMappingURL=FloatingButtonGroup.js.map
